import { Injectable } from '@angular/core';
import { Player } from 'fl-player-interface';

@Injectable({
  providedIn: 'root',
})
export class ClevertapPlayerStore {
  private playerInstance: any;
  private playerConfig: any;

  public setPlayer(player: any) {
    this.playerInstance = player;
  }

  public setPlayerConfig(playerConfig: any) {
    this.playerConfig = playerConfig;
  }

  public getPlayer(): Player {
    return this.playerInstance;
  }

  public getPlayerInfo(): any {
    if (!this.playerInstance) return {};
    return {
      contentDuration: this.playerInstance?.duration
        ? this.playerInstance?.duration
        : 0,
      timeToFirstByte: this.playerConfig?.timeToFirstByte,
      bitrate:
        this.playerInstance?.availableBitrates[
          this.playerInstance?.availableBitrates?.length - 1
        ],
      playbackType: this.playerConfig.contentType,
      ccEnabled:
        this.playerInstance.getActiveTracks() &&
        this.playerInstance
          .getActiveTracks()
          ?.find((element: any) => element.type === 'text') !== undefined,
      bufferTime: this.playerInstance?.playbackStatistics
        ? this.playerInstance?.playbackStatistics?.bufferingTime
        : 0,
      streamPercentage: this.playerInstance?.currentTime
        ? (
            (this.playerInstance?.currentTime * 100) /
            this.playerInstance?.duration
          ).toFixed(2)
        : 0,
    };
  }
}
